var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBecksIconsCmsHamburgersHotDogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-2{fill:#231f20;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.93,98.5H27.87c-6.76,0-14.42-7.66-14.42-14.42h0c0-3.96,3.21-4.98,7.17-4.98H100.18c3.96,0,7.17,1.03,7.17,4.98h0c0,6.76-7.66,14.42-14.42,14.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.29,66.96h14.21c2.7,0,4.89,2.19,4.89,4.89v2.13c0,2.7-2.19,4.89-4.89,4.89H19.3c-2.7,0-4.89-2.19-4.89-4.89v-2.13c0-2.7,2.19-4.89,4.89-4.89H58.93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.3,66.9h-15.01l-14.4,6.51-12.64-6.51H18.51c-1.54,0-4.1-1.14-4.1-3.62h0c0-2.48,2.56-6.24,4.1-6.24H102.3c1.54,0,4.1,3.76,4.1,6.24h0c0,2.48-2.56,3.62-4.1,3.62Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.7,57.05H16.1c-1.52,0-2.69-1.42-2.51-3.03,2.03-18.27,22.21-32.62,46.81-32.62s44.78,14.35,46.81,32.62c.18,1.61-.99,3.03-2.51,3.03Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 43.69,
    cy: 37.47,
    r: 3.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.41,
    cy: 37.35,
    r: 3.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 32.41,
    cy: 45.35,
    r: 3.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 61.41,
    cy: 45.35,
    r: 3.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 91.41,
    cy: 46.35,
    r: 3.1
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecksIconsCmsHamburgersHotDogs);
export default __webpack_public_path__ + "static/media/BecksIcons_CMS_HamburgersHotDogs.196f410a4b5fe42e9327b39d1715d49e.svg";
export { ForwardRef as ReactComponent };